var _desc, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    "aria-describedby": "desc",
    role: "img",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    strokeWidth: 3,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Roast Chicken") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A line styled icon from Orion Icon Library.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M54.867 24.717l2.326-2.326a2.94 2.94 0 0 0 3.939-4.355c-1.523-1.523-2.088-1.047-2.6-1.562-.709-.709-.3-1.344-1.564-2.6a2.947 2.947 0 0 0-4.168 4.161c.072.072.16.115.238.18l-2.818 2.814M62 51a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2 2 2 0 0 1 2-2h56a2 2 0 0 1 2 2z",
    "data-name": "layer2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M34.291 42.082a10.058 10.058 0 0 0 14.979-.824c.049-.062.092-.129.139-.191.16-.207.316-.416.457-.633 2.972-4.459 3.234-11.059 4.434-12.256l.34-.34a2.4 2.4 0 0 0 0-3.391l-2.713-2.713a2.4 2.4 0 0 0-3.393 0l-.34.34c-1.283 1.283-8.416 1.144-13.115 5.059-.271.221-.533.455-.787.707a10.069 10.069 0 0 0-.001 14.242z",
    "data-name": "layer1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M49.748 21.031C44 11 16 3 3.379 30.154c-3.592 8 2.627 14.877 10.627 14.877h27.826",
    "data-name": "layer1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoast);
export default __webpack_public_path__ + "static/media/roast.df8bcada.svg";
export { ForwardRef as ReactComponent };